import { ResolveEnvironment } from 'phoenix/constants';
import { GetUseWhitelabel } from 'phoenix/util';

export enum Whitelabel {
    Aiva = 'Aiva',
    Galicia = 'Galicia',
    Winexco = 'Winexco',
    FolioNet = 'folionet',
    AvSecurities = 'avsecurities',
    ConosurInversiones = 'conosurinversiones',
    Apac = 'apac',
    BalanzCapital = 'balanzcapital',
    BalanzUruguay = 'balanzuruguay',
    MmgBank = 'mmgbank',
    BacValores = 'bacvalores',
}

export const WhitelabelFormattedNames: Record<Whitelabel, string> = {
    [Whitelabel.Aiva]: 'Aiva',
    [Whitelabel.Galicia]: 'Galicia',
    [Whitelabel.Winexco]: 'Winexco',
    [Whitelabel.FolioNet]: 'Folionet',
    [Whitelabel.AvSecurities]: 'AV Securities',
    [Whitelabel.ConosurInversiones]: 'Conosur Inversiones',
    [Whitelabel.Apac]: 'Apac',
    [Whitelabel.BalanzCapital]: 'Balanz Capital',
    [Whitelabel.BalanzUruguay]: 'Balanz Uruguay',
    [Whitelabel.MmgBank]: 'MMG Bank',
    [Whitelabel.BacValores]: 'Bac Valores',
};

export const GetWhitelabel = (): Whitelabel | null => {
    const env = ResolveEnvironment();
    if (env === Whitelabel.Aiva || GetUseWhitelabel()?.toLowerCase() === Whitelabel.Aiva.toLowerCase()) return Whitelabel.Aiva;
    if (env === Whitelabel.Galicia || GetUseWhitelabel()?.toLowerCase() === Whitelabel.Galicia.toLowerCase()) return Whitelabel.Galicia;
    if (env === Whitelabel.Winexco || GetUseWhitelabel()?.toLowerCase() === Whitelabel.Winexco.toLowerCase()) return Whitelabel.Winexco;
    if (env === Whitelabel.FolioNet || GetUseWhitelabel()?.toLowerCase() === Whitelabel.FolioNet.toLowerCase()) return Whitelabel.FolioNet;
    if (env === Whitelabel.AvSecurities || GetUseWhitelabel()?.toLowerCase() === Whitelabel.AvSecurities.toLowerCase()) return Whitelabel.AvSecurities;
    if (env === Whitelabel.ConosurInversiones || GetUseWhitelabel()?.toLowerCase() === Whitelabel.ConosurInversiones.toLowerCase()) return Whitelabel.ConosurInversiones;
    if (env === Whitelabel.Apac || GetUseWhitelabel()?.toLowerCase() === Whitelabel.Apac.toLowerCase()) return Whitelabel.Apac;
    if (env === Whitelabel.BalanzCapital || GetUseWhitelabel()?.toLowerCase() === Whitelabel.BalanzCapital.toLowerCase()) return Whitelabel.BalanzCapital;
    if (env === Whitelabel.BalanzUruguay || GetUseWhitelabel()?.toLowerCase() === Whitelabel.BalanzUruguay.toLowerCase()) return Whitelabel.BalanzUruguay;
    if (env === Whitelabel.MmgBank || GetUseWhitelabel()?.toLowerCase() === Whitelabel.MmgBank.toLowerCase()) return Whitelabel.MmgBank;
    if (env === Whitelabel.BacValores || GetUseWhitelabel()?.toLowerCase() === Whitelabel.BacValores.toLowerCase()) return Whitelabel.BacValores;
    return null;
};

export const IsDebugWhitelabel = (): boolean => {
    const whitelabels = Object.values(Whitelabel);
    const debugSetting = GetUseWhitelabel()?.toLowerCase();
    const whitelabelStrings = whitelabels.map((w) => w.toString().toLowerCase());
    return whitelabelStrings.includes(debugSetting);
};

const IsEnvWhitelabel = (): boolean => {
    const env = ResolveEnvironment();
    const whitelabels = Object.values(Whitelabel);
    return whitelabels.includes(env as unknown as Whitelabel);
};

export const IsWhitelabel = (): boolean => IsEnvWhitelabel() || IsDebugWhitelabel();

export function isWhitelabel(thing: unknown): thing is Whitelabel {
    return Object.values(Whitelabel).includes(thing as Whitelabel);
}

const MatchesWhitelabel = (whitelabel: Whitelabel): boolean => {
    const env = ResolveEnvironment();
    return env === whitelabel?.toLowerCase();
};

export const IsAiva = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.Aiva.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.Aiva);
export const IsGalicia = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.Galicia.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.Galicia);
export const IsWinexco = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.Winexco.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.Winexco);
export const IsFolioNet = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.FolioNet.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.FolioNet);
export const IsAvSecurities = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.AvSecurities.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.AvSecurities);
export const IsConosurInversiones = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.ConosurInversiones.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.ConosurInversiones);
export const Apac = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.Apac.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.Apac);
export const IsBalanzCapital = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.BalanzCapital.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.BalanzCapital);
export const IsBalanzUruguay = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.BalanzUruguay.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.BalanzUruguay);
export const IsMmgBank = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.MmgBank.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.MmgBank);
export const IsBacValores = (): boolean => GetUseWhitelabel()?.toLowerCase() === Whitelabel.BacValores.toString().toLowerCase() || MatchesWhitelabel(Whitelabel.BacValores);